function initProcessingFeeUI(root = document) {
  const checkboxes = root.querySelectorAll('.js-cover-fee');

  checkboxes.forEach((cb) => {
    const form = cb.closest('form');
    const wrapper = cb.closest('.processing-fee-inline') || cb.closest('label');
    const hint = wrapper ? wrapper.querySelector('.fee-inline-hint') : null;
    if (!form || !wrapper || !hint) return;

    const feePercent = parseFloat(cb.dataset.feePercent || '0.03');

    const fmtDollars = (cents) => (Math.round(cents) / 100).toFixed(2);

    const calcBaseCents = () => {
      const inputs = form.querySelectorAll('.js-assignment-amount');
      if (inputs.length) {
        let sumCents = 0;
        inputs.forEach((el) => {
          const v = parseFloat(String(el.value || '').replace(',', '.')); 
          if (!isNaN(v)) sumCents += Math.round(v * 100);
        });
        return sumCents;
      }
      const fallback = parseInt(cb.dataset.baseAmountCents || cb.dataset.baseAmount || '0', 10);
      return isNaN(fallback) ? 0 : fallback;
    };

    const render = () => {
      const baseCents = calcBaseCents();
      if (cb.checked) {
        const feeCents   = Math.round(baseCents * feePercent);
        const totalCents = baseCents + feeCents;
        hint.textContent = ` (3% = $${fmtDollars(feeCents)}, total = $${fmtDollars(totalCents)})`;
      } else {
        hint.textContent = '';
      }
    };

    cb.addEventListener('change', render);
    form.addEventListener('input', (e) => {
      if (e.target && e.target.matches('.js-assignment-amount')) render();
    });
    form.addEventListener('change', (e) => {
      if (e.target && e.target.matches('.js-assignment-amount')) render();
    });

    render();
  });
}

document.addEventListener('DOMContentLoaded', () => initProcessingFeeUI(document));